export const d2024 = {
  "item": [
    {
      "dateKind": "01",
      "dateName": "1월1일",
      "isHoliday": "Y",
      "locdate": 20240101,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240209,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240210,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240211,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일(설날)",
      "isHoliday": "Y",
      "locdate": 20240212,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "삼일절",
      "isHoliday": "Y",
      "locdate": 20240301,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "국회의원선거",
      "isHoliday": "Y",
      "locdate": 20240410,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "어린이날",
      "isHoliday": "Y",
      "locdate": 20240505,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일(어린이날)",
      "isHoliday": "Y",
      "locdate": 20240506,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "부처님오신날",
      "isHoliday": "Y",
      "locdate": 20240515,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "현충일",
      "isHoliday": "Y",
      "locdate": 20240606,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "광복절",
      "isHoliday": "Y",
      "locdate": 20240815,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240916,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240917,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240918,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "개천절",
      "isHoliday": "Y",
      "locdate": 20241003,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "한글날",
      "isHoliday": "Y",
      "locdate": 20241009,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "기독탄신일",
      "isHoliday": "Y",
      "locdate": 20241225,
      "seq": 1
    }
  ]
};

export const d2025 = {
  "item": [
    {
      "dateKind": "01",
      "dateName": "1월1일",
      "isHoliday": "Y",
      "locdate": 20250101,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250128,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250129,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250130,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "삼일절",
      "isHoliday": "Y",
      "locdate": 20250301,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20250303,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "어린이날",
      "isHoliday": "Y",
      "locdate": 20250505,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "부처님오신날",
      "isHoliday": "Y",
      "locdate": 20250505,
      "seq": 2
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20250506,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "현충일",
      "isHoliday": "Y",
      "locdate": 20250606,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "광복절",
      "isHoliday": "Y",
      "locdate": 20250815,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "개천절",
      "isHoliday": "Y",
      "locdate": 20251003,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251005,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251006,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251007,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20251008,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "한글날",
      "isHoliday": "Y",
      "locdate": 20251009,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "기독탄신일",
      "isHoliday": "Y",
      "locdate": 20251225,
      "seq": 1
    }
  ]
};